import React from "react";
import 'animate.css';

import ArrowDecor from "../../img/decor/arrow-decor.webp";


function AdvantagesOne({advantagesData}) {

    //console.log(advantagesData);

    return (
        advantagesData ?

        <section className="relative bg-[#00007c] mb-[60px] lg:mb-[120px] py-[60px] lg:py-[100px] xl:py-[120px] overflow-hidden"> 

            
            <div className="container max-w-full mx-auto px-[clamp(20px,calc(20px+130*((100vw-390px)/1530)),150px)]">

                <h2 className="relative z-20 leading-tight text-[clamp(34px,calc(34px+53*((100vw-390px)/1530)),87px)] text-[#babafe] uppercase mb-[40px]
                    xl:mb-[87px]">{advantagesData.advantages_title}</h2>

                <div>
                {
                    advantagesData.advantages_repeater ?
                        advantagesData.advantages_repeater.map((item, value) => (

                            <div key={`advantages-${value}`} className="group relative transition-colors duration-300 
                                flex gap-[clamp(16px,calc(16px+32*((100vw-390px)/1530)),48px)]
                                border-b border-white/25 py-[clamp(24px,calc(24px+26*((100vw-390px)/1530)),50px)]
                                text-white first:border-t">

                                <div className="absolute top-0 -left-[50vw] w-[150vw] h-[100%] bg-white/20 opacity-0 xl:group-hover:opacity-100"></div>

                                <span className="text-[14px] font-medium uppercase pt-[5px] lg:text-[18px] xl:text-[22px]">
                                    {String(value + 1).padStart(2, "0")}
                                </span>
                                
                                <div className="lg:flex gap-[clamp(36px,calc(36px+74*((100vw-1024px)/896)),110px)]">
                                    <h4 className="text-[clamp(20px,calc(20px+15*((100vw-390px)/1530)),35px)] font-bold uppercase mb-[10px] lg:mb-0
                                        lg:w-[390px]  xl:w-auto">{item.advantages_repeater_title}</h4>
                                    <p className="text-base leading-tight font-normal max-md:w-[60%] lg:max-w-[230px]
                                        xl:opacity-0 xl:group-hover:opacity-100 duration-300 text-balance">{item.advantages_repeater_text}</p>
                                </div>
                                
                                <div className="absolute right-0 bottom-1 size-[38px] lg:size-[46px]
                                    xl:top-1/2 xl:-translate-y-1/2 bottom-none xl:size-[205px]
                                    xl:opacity-0 xl:group-hover:opacity-100 duration-300">


                                    <div className="bg-[linear-gradient(180deg,rgba(0,0,124,0)_0%,#00007c_100%)]
                                        absolute -bottom-1 left-0 z-10 w-full h-full xl:hidden"></div>
                                    <img src={ArrowDecor} alt="icon" className="w-full"/>
                                </div>
                            </div>

                        )) : ''
                }
                </div>


            </div>
            
        </section> : ''
    )
}

export default AdvantagesOne